/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyInactivationViewModel } from "../types/AssociatedCompanyInactivationViewModel.ts";

export const associatedCompanyInactivationViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  active: z.optional(z.boolean()),
  inactiveDate: z.string().datetime().nullish(),
}) as unknown as ToZod<AssociatedCompanyInactivationViewModel>;
